import React from "react";
import { formatCurrency } from "../../helpers/estimateTotals";
import { BUDGET_WARNING } from "../../helpers/projectBudgetWarnings";
import "./ProjectBudgetWarnings.css";

const COPY = {
  [BUDGET_WARNING.OVER_BUDGET]: (amount) => ({
    title: "Over budget",
    body: `Actual cost is ${formatCurrency(amount)} over the project budget.`,
  }),
  [BUDGET_WARNING.OVER_QUOTE]: (amount) => ({
    title: "Over quote",
    body: `Actual cost is ${formatCurrency(amount)} over the quoted amount.`,
  }),
  [BUDGET_WARNING.NEGATIVE_MARGIN]: (amount) => ({
    title: "Negative margin",
    body: `Billed so far is ${formatCurrency(amount)} below actual cost.`,
  }),
};

/** B4: compact over-budget / margin warnings. Renders nothing when on track. */
export function ProjectBudgetWarnings({ warnings = [] }) {
  if (!warnings.length) return null;
  return (
    <div className="pj-budget-warn" role="status" aria-live="polite" data-testid="project-budget-warnings">
      {warnings.map(({ id, amount }) => {
        const copy = COPY[id]?.(amount);
        if (!copy) return null;
        return (
          <div key={id} className="pj-budget-warn__item" data-warning={id}>
            <span className="pj-budget-warn__icon" aria-hidden="true">!</span>
            <span className="pj-budget-warn__text">
              <b>{copy.title}</b> <span>{copy.body}</span>
            </span>
          </div>
        );
      })}
    </div>
  );
}
